import { Toaster as LibToaster, ToasterProps } from 'react-hot-toast';

const Toaster = (props: ToasterProps) => <LibToaster {...props} />;

export default Toaster;
